import React, { useState } from 'react';
import { DATE_FORMAT } from 'lib/api/repairOrders/const';
import dayjs from 'dayjs';
import { TableScoreboard } from './TableScoreboard';
import { useGetTopCtaVideosQuery } from 'lib/api/metrics/queryTopCta';

type BestPerformingCtasProps = {
  from: Date;
  to: Date;
  users?: string[];
  label: string;
};

export const BestPerformingCtas = ({
  from,
  to,
  users = [],
  label,
}: BestPerformingCtasProps) => {
  const [retryCount, setRetryCount] = useState(0);

  const params = {
    from: dayjs(from).format(DATE_FORMAT),
    to: dayjs(to).format(DATE_FORMAT),
    users: users.join(','),
    retryCount,
  };

  const {
    data: ctas,
    error,
    isLoading,
    isRefetching,
  } = useGetTopCtaVideosQuery({ params, enabled: true });

  return (
    <TableScoreboard
      data={ctas?.map(cta => ({
        title: cta.linkText,
        cnt: cta.cnt,
      }))}
      label={label}
      setRetryCount={setRetryCount}
      retryCount={retryCount}
      isLoading={isLoading}
      isRefetching={isRefetching}
      error={error}
    />
  );
};
